/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React from 'react';
import { useIntl } from 'react-intl';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { useRecoilState } from 'recoil';
import { enableChangesAtom } from '../Atoms';

const ChangesSwitch = function ChangesSwitch() {
  const intl = useIntl();
  const [enableChanges, setEnableChanges] = useRecoilState(enableChangesAtom);

  const handleChange = (event) => {
    setEnableChanges(event.target.checked);
  };

  return (
    <div className="c-switch">
      <div
        className="switch"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2">{intl.messages.ENABLECHANGES}</Typography>
        <Switch sx={{ m: 1 }} checked={enableChanges} onChange={handleChange} color="variant" />
      </div>
    </div>
  );
};

export default ChangesSwitch;
